export default __webpack_public_path__ + "static/media/home_button.2401d1bd.png";